<div class="card bg-card-new card-radius-06 border-0" *ngIf="bookings && bookings.length">
  <div class="card-header">
    <h4>{{ 'booking_history' | translate }}</h4>
  </div>
  <div class="card-table py-4 px-6">
    <div class="table-responsive-sm">
      <table>
        <thead>
          <tr>
            <th>{{ 'booking_details' | translate }}</th>
            <th>{{ 'booking_date' | translate }}</th>
            <th>{{ 'start_date' | translate }}</th>
            <th>{{ 'period' | translate }}</th>
            <th>{{ 'quantity' | translate }}</th>
            <th>{{ 'total' | translate }}</th>
            <th>{{ 'order' | translate }}</th>
            <th>{{ 'quotation' | translate }}</th>
            <th>{{ 'status' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let booking of bookings">
            <td>
              <div class="booking-details">
                <div class="product-name">
                  {{ getProductName(booking) }}
                </div>
                <div class="company-name text-muted">
                  {{ getCompanyName(booking) }}
                </div>
                <span class="booking-number">#{{ booking.bookingNumber || booking._id }}</span>
              </div>
            </td>
            <td>
              <div class="booking-date">
                {{ getBookingDate(booking) }}
              </div>
            </td>
            <td>
              <div class="start-date">
                {{ getStartDate(booking) }}
              </div>
            </td>
            <td>
              <div class="period-info">
                <!-- Per Day Booking -->
                <div *ngIf="booking.bookingType === 'perDay'" class="per-day-period">
                  <div class="period-count">{{ getBookingDaysCount(booking) }} {{ 'days' | translate }}</div>
                  <div class="dates-scroll" *ngIf="booking.bookingDates && booking.bookingDates.length > 1">
                    <span *ngFor="let date of booking.bookingDates; let last = last" class="date-item">
                      {{ formatDate(date) }}<span *ngIf="!last">,</span>
                    </span>
                  </div>
                </div>

                <!-- Time Slots Booking -->
                <div *ngIf="booking.bookingType === 'timeSlots'" class="time-slots-period">
                  <div class="period-count">{{ getTotalSlots(booking) }} {{ 'slots' | translate }}</div>
                  <div class="slots-scroll" *ngIf="booking.timeSlots && booking.timeSlots.length">
                    <span *ngFor="let slot of booking.timeSlots; let last = last" class="slot-item">
                      {{ formatTime(slot.startTime) }}-{{ formatTime(slot.endTime) }}<span *ngIf="!last">,</span>
                    </span>
                  </div>
                </div>

                <!-- Period Booking -->
                <div *ngIf="booking.bookingType === 'period'" class="period-period">
                  <div class="period-count">{{ getPeriodDuration(booking) }}</div>
                  <div class="end-date">{{ 'end' | translate }}: {{ formatDate(booking.endDate) }}</div>
                </div>
              </div>
            </td>

            <!-- Quantity -->
            <td>
              <div class="quantity-cell">
                {{ booking.quantity ?? '--' }}
              </div>
            </td>

            <!-- Total Price (show currency if present) -->
            <td>
              <div class="total-cell">
                <span *ngIf="booking.totalPrice != null">
                  {{ booking.totalPrice | currencyConvert: booking.currency }}
                </span>
                <span *ngIf="booking.totalPrice == null">--</span>
              </div>
            </td>

            <!-- View Order -->
            <td class="text-left">
              <ng-container *ngIf="booking.orderId; else noOrder">
                <a [routerLink]="['/account/orders', booking.orderId]" class="booking-link">
                  {{ 'view_order' | translate }}
                </a>
              </ng-container>
              <ng-template #noOrder><span class="text-muted">--</span></ng-template>
            </td>
            
            <!-- View Quotation -->
            <td class="text-left">
              <ng-container *ngIf="booking.rfqId; else noRfq">
                <a [routerLink]="['/rfq/response', booking.rfqId]" class="booking-link">
                  {{ 'view_rfq' | translate }}
                </a>
              </ng-container>
              <ng-template #noRfq><span class="text-muted">--</span></ng-template>
            </td>

            <td>
              <span class="status-badge" [ngClass]="getStatusClass(booking)">
                {{ getStatus(booking) }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="paginationBookingCount > 1">
    <div class="card-footer">
      <app-pagination (pageChange)="updateBookingsList($event)" [total]="paginationBookingCount"></app-pagination>
    </div>
  </div>
</div>

<!-- Loading State -->
<div *ngIf="loading" class="loading-container">
  <div class="loading-content">
    <div class="spinner"></div>
    <div class="loading-text">{{ 'loading_bookings' | translate }}</div>
  </div>
</div>

<!-- No Bookings State -->
<div *ngIf="!loading && (!bookings || bookings.length === 0)" class="no-bookings-container">
  <div class="no-bookings-content">
    <div class="no-bookings-icon">
      <mat-icon>calendar_month</mat-icon>
    </div>
    <div class="no-bookings-message">
      {{ 'no_bookings_message' | translate }}
    </div>
  </div>
</div>
